module.exports = __webpack_public_path__ + "img/construction.9b4d79ac.jpg";